import { useQuery } from '@tanstack/react-query'
import { agendaService } from '@/services/agenda'

export function useClientSearch(search: string) {
  return useQuery({
    queryKey: ['client-search', search],
    queryFn: () => agendaService.searchClients(search, 10),
    enabled: search.length >= 2,
    staleTime: 30000,
  })
}
